/* eslint-disable no-restricted-globals */
import getCookie from 'core/lib/getCookie';
import { noop } from 'lodash';

import ApiError from './ApiError';
import { API_URL } from './constants';

const addAntiForgeryHeader = (headers: Array<Array<string>>): Array<Array<string>> => {
    const token = getCookie('XSRF-TOKEN');
    if (!token) {
        return headers;
    }
    return [['X-XSRF-TOKEN', token], ...headers];
};

export const getApiRequestInit = (init: RequestInit = {}): RequestInit => {
    const { headers = [] } = init;
    const requestInit: RequestInit = {
        credentials: 'include',
        mode: 'cors',
        ...init,
        headers: addAntiForgeryHeader([
            // Prevent IE11's over-aggressive caching
            ['pragma', 'no-cache'],
            ['Cache-Control', 'no-cache'],
            ...(headers as Array<Array<string>>),
        ]) as HeadersInit,
    };
    return requestInit;
};

export const injectCulture = (url: string, culture?: string): string => {
    if (!culture) {
        return url;
    }
    const cultureParam = `ui-culture=${culture}`;
    const hasQueryString = url.indexOf('?') > -1;
    const glue = hasQueryString ? '&' : '?';
    return url + glue + cultureParam;
};

const apiFetch: WindowOrWorkerGlobalScope['fetch'] = async (input, init = {}) => {
    const response = await fetch(input, getApiRequestInit(init));
    if (response.status === 401) {
        const stall = new Promise<Response>(noop);
        const redirectUrl = encodeURIComponent(location.href);
        const href = `${API_URL}/api/v1/Auth/AdLogin?redirectUrl=${redirectUrl}`;
        location.href = href;

        // Don't resolve or reject here since we're redirecting to Active Directory's login
        // and we don't want to flash an error or cause unnecessary re-renders.
        return await stall;
    }
    if (!response.ok) {
        throw new ApiError(response);
    }
    return response;
};

export default apiFetch;
